import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Button, Alert } from 'reactstrap';
import Maps from 'containers/Maps';
import Duplicates from './Duplicates';
import LocationSearchInput from 'components/LocationSearchInput';
import IntlMessages from 'util/IntlMessages';

class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: null
    };
  }

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  // }

  render() {
    const { colors, types, modules } = this.props.settings;
    const { mapCenter, mapZoom, path, mapRestrictedArea } = this.props.settings.general;
    const { selectedPosition, panTo } = this.props;
    // console.log('general: ', this.props.settings.general);
    //console.log('settings: ', this.props.settings);

    //    console.log('modules:', modules);

    //    console.log('panTo:', panTo);

    return (
      <div className="row">
        <div className={modules.reportDuplicates ? 'col-lg-8 col-md-12' : 'col-lg-12 col-md-12'}>
          <Card>
            <CardHeader className="custom-main">
              <IntlMessages id="meldooWeb.newReport.location.title" />
            </CardHeader>
            <CardBody className="p-0">
              <div className="p-2" style={{ position: 'absolute', zIndex: 1, right: 0 }}>
                <LocationSearchInput onSelectLocation={latlng => this.props.onSetPosition(latlng)} />
              </div>
              <Maps
                center={mapCenter}
                panTo={panTo ? selectedPosition : ''}
                data={modules.reportDuplicates ? this.props.reports : []}
                types={types}
                dimensions={modules.reportDuplicates ? '4by3' : '21by9'}
                selectedLocation={this.props.selectedPosition}
                onSelectionMarkerDragEnd={latlng => this.props.onSelectPosition(latlng)}
                onClick={latlng => this.props.onSelectPosition(latlng)}
                markerOpacity={0.5}
                mapsFillColor={colors.maps.fill ? colors.maps.fill : null}
                mapsStrokeColor={colors.maps.stroke ? colors.maps.stroke : null}
                limitArea={mapRestrictedArea ? true : false}
                zoom={mapZoom}
                polygons={path.map(pathA => {
                  return {
                    paths: pathA.map(pathB => {
                      return pathB.map(coodinates => {
                        return {
                          lat: coodinates.y,
                          lng: coodinates.x
                        };
                      });
                    })
                  };
                })}
              />
            </CardBody>
          </Card>
          <Alert className="border" style={{ backgroundColor: colors.error.bg, color: colors.error.font }} isOpen={this.props.errorMessages.position}>
            <IntlMessages id="meldooWeb.newReport.errors.position" />
          </Alert>
          <div className="d-flex w-100 justify-content-between">
            {modules.reportCollection && (
              <Button color="default" className="jr-btn jr-btn-default custom-previous" onClick={this.props.onPreviousStep}>
                <i className="zmdi zmdi-chevron-left zmdi-hc-lg" />
                <IntlMessages id="meldooWeb.newReport.previousStep" />
              </Button>
            )}
            <Button
              color="default"
              className="jr-btn jr-btn-default custom-next"
              onClick={this.props.onNextStep}
              disabled={!this.props.selectedPosition}
            >
              <IntlMessages id="meldooWeb.newReport.nextStep" />
              <i className="zmdi zmdi-chevron-right zmdi-hc-lg" />
            </Button>
          </div>
        </div>
        {modules.reportDuplicates && (
          <div className="col-lg-4 col-md-12">
            <Duplicates duplicates={this.props.duplicates} colors={colors} toReport={this.props.toReport} />
          </div>
        )}
      </div>
    );
  }
}

export default Location;



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/NewReport/Component/Location.js